export default {
  cloneFromType: {
    survey: 'Survey',
    template: 'Template',
  },
  createSurvey: 'Create Survey',
  createTemplate: 'Create Template',
  newSurvey: 'New Survey',
  newSurveyFromScratch: 'New Survey From Scratch',
  newTemplate: 'New Template',
  newTemplateFromScratch: 'New Template From Scratch',
  source: {
    label: 'Source',
    arena: 'Arena (.zip)',
    collect: 'Collect (.collect, .collect-backup, .collect-data)',
  },
  startImport: 'Start import',
  survey: 'Survey',
  survey_other: 'Surveys',
  template: 'Template',
  template_other: 'Templates',
  error: 'Error creating new survey',
  errorMaxSurveysCountExceeded: `Error creating survey; you have reached the maximum number of surveys you can create ({{maxSurveysCount}}).`,
  options: {
    includeData: 'Include data',
  },
}
